// const {debounceTime, addEvent} = theme;

customElements.define('filter-component', class extends HTMLElement {
  constructor() {
    super();

    this.container = this.closest('[data-section-id]');
    this.cache = [];
    this.andLogic = JSON.parse(this.dataset.andLogic || 'false');
    this.filterType = this.dataset.type || 'attribute';
    this.form = this.querySelector('form');
    this.inputClass = `input[form="${this.form.id}"]`;
    this.close_notify = this.querySelector('.close-box');
    this.active_filter = this.querySelector('.active-filter');
    this.btn_reset = this.querySelector('.btn-filter-reset');
    this.loading = this.querySelector('.loading-icon');
    
  }

  connectedCallback(){
    this.addEvents();
  }

  addEvents(){

    this.addEventListener('change', ({target})=>{
      let selectedTarget = target;

      if(selectedTarget.name == 'sortBy'){// Fix duplicate sort input
        const sortEl = [...this.querySelectorAll('[name=sort_by]')].find(item=>item.value == selectedTarget.value);
        sortEl.checked = true;
        selectedTarget = sortEl;
      }

      this.onChange(selectedTarget);
    })

    this.close_notify?.addEventListener('click', (e) =>{
        //console.log('target',e.target)
        e.target.parentElement.style.display = 'none'; 
    })


    this.form.addEventListener('submit', e=>{
      e.preventDefault();

      this.submit();
    });

    // Remove all checked input in filter popup
    this.querySelector('.jsFilterReset')?.addEventListener('click', e=>{
      e.preventDefault();

      this.uncheckInput();
      this.submit();
      //this.btn_reset.style.display = 'none';
    });

    this.removeFilter();
    this.filterSearch();
  }

  onChange(target){
    console.log('target' , target)
    const input = target;

    !this.andLogic && this.uncheckInput(input);

    if(target.hasAttribute('auto-submit'))
      this.submit();
  }

  uncheckInput(input = null){
    let inputList;

    if(input){
      inputList = this.querySelectorAll(`input[name="${input.name}"][form="${this.form.id}"]:not([id="${input.id}"])`);
    }
    else{
      inputList = this.querySelectorAll(`input[form="${this.form.id}"]`);
    }

    inputList.forEach(i=>{
      i.removeAttribute('checked');
      i.checked = false;
    });
  }

  get getQueryString(){
    const formData = new FormData(this.form);
    const query = new URLSearchParams(formData);

    if(this.filterType == 'attribute')
      return query.toString();

    const arrayFilter = [];
    let sort = '';

    query.split('&').map(i=>{
      !i.includes('sort_by=') ? arrayFilter.push(i.split('=')[1]) : (sort = i);
    });

    return arrayFilter.join('+') + (sort.length ? `?${sort}` : '');
  }

  submit(){

    const query = this.getQueryString;
    //cache
    // const findInCache = this.cache.find(i=>i.query == query);

    // if (findInCache){
    //   this.render(findInCache.DOM, findInCache.query);
    //   return;
    // }

    let url = this.form.action;
    url += this.filterType == 'attribute' ? '?':'/';
    url += query;
    url += (this.filterType == 'attribute' || query.includes('?')) ? '&':'?';
    url += `section_id=${this.dataset.sectionId}`;

    let body = document.querySelector('body');
    body.classList.add('lock-scroll')
    this.loading.classList.remove('none');
    // console.log('url' , url)

    fetch(url)
    .then(e=>e.text())
    .then(html=>{

      const div = document.createElement('div');
      div.innerHTML = html;

      this.cache.push({
        query: query,
        DOM: div
      })
      
      this.render(div, query);
      this.loading.classList.add('none');
      body.classList.remove('lock-scroll')
    })
  }

  render(result, searchParams = null){

    if(searchParams){
      let splitCharacter = this.filterType == 'attribute' ? '?' : (!searchParams.includes('?') || (searchParams.includes('?') && searchParams.split('?')[0].length)) ? '/' : '';
      history.pushState({ searchParams }, '', `${this.form.action}${searchParams && splitCharacter.concat(searchParams)}`);
    }

    // Update input state
    this.querySelectorAll(this.inputClass).forEach((input, i)=>{
      if(!input.id) return;

      input.checked = result.querySelector(`#${input.id}`)?.checked || false;
    });

    // Update product list
    // console.log('result', result)
    // this.querySelector('#'+this.dataset.product).innerHTML = result.querySelector('#'+this.dataset.product).innerHTML;
    if(result.querySelector('.result-container') != null)
    {
        this.querySelector('.result-container').innerHTML = result.querySelector('.result-container').innerHTML;
    }
    else
    {
        this.querySelector('.result-container').innerHTML = 'No products find in results'
    }
 
    // this.querySelector('#'+this.dataset.product).replaceWith(result.querySelector('#'+this.dataset.product));

    /* Update item */
    this.querySelectorAll('.jsFilterUpdate')?.forEach(item=>{
      //console.log('item', item )
      const newItem = result.querySelector(`[class="${item.className}"]`);
      if(!newItem) return;

      item.innerHTML = newItem.innerHTML;
    });
    // console.log('test')
    //console.log('this.active_filter', this.active_filter)
    let active_filter = this.active_filter.innerHTML.toString();
    if (active_filter == '0') 
    {
      this.btn_reset.style.display = 'none';
      //console.log('case1')
    }
    else {
      this.btn_reset.style.display = 'block';
      //console.log('case2')
    }
    //console.log('')
    

    this.removeFilter();
  }

  removeFilter(){
    this.querySelectorAll('.jsFilterRemove')?.forEach(item=>{
      item.addEventListener('click', event=>{
        event.preventDefault();

        let value = item.querySelector('.jsValue').textContent;
        if(value == 'In stock')
        {
            value = 1;
        }
        if(value == 'Out of stock')
        {
            value = 0;
        }
        this.querySelectorAll(`input[form="${this.form.id}"]`).forEach(item=>{
        // console.log('value1',item.value)
        // console.log('value2',value)
          if(item.value != value) return;

          item.checked = false;
        });

        this.submit();
      })
    })
  }

  filterSearch(){

    this.querySelectorAll('.jsFilterSearch')?.forEach(item=>{
      const parentEl = item.closest('.filter-block');

      item.addEventListener('click', ()=>{
        const value = item.previousElementSibling.value;
        searchFilterValue(parentEl, value);
      })


      item.previousElementSibling.addEventListener('keyup', e=>{
        (e.keyCode == 8 || !item.previousElementSibling.value.length) && clearField(parentEl);

        // if(e.keyCode != 13) return
        const value = item.previousElementSibling.value;
        searchFilterValue(parentEl, value);
      })
    })

    const clearField = (el)=>{
      el.querySelectorAll('li.matched')?.forEach(item=>item.classList.remove('matched'));
    }

    const searchFilterValue = (container, value)=>{
      const filterListItem = container.querySelectorAll('[name*=filter]');

      if(value.length){
        container.classList.add('searching');

        filterListItem.forEach(item=>{
          let regex = new RegExp(value, 'i');
          const parentEl = item.closest('li');

          parentEl.classList.toggle('matched', item.value.match(regex));
        });
      }
      else{
        container.classList.remove('searching');
        container.querySelectorAll('.matched')?.forEach(item=>item.classList.remove('matched'));
      }

      container.querySelector('.jsFilterShowMore')?.classList.toggle('none', value.length);
    }
  }
});

// addEvent('click', '.jsFilterShowMore', ({target})=>{
//   const container = target.closest('.filter-block');

//   const filterList = container.querySelectorAll('.jsFilterToggle.none');
//   filterList.forEach((item, value)=>{
//     value < 10 && item.classList.remove('none');
//   });
  
//   const hiddenFilterCount = container.querySelectorAll('.jsFilterToggle.none').length;
//   !hiddenFilterCount && target.classList.add('none');
//   target.querySelector('.attr-count').setAttribute('data-count', Math.min(10, hiddenFilterCount));
// })